const authServiceUrl = 'https://g-go-api2.augmedix.com/auth/v1';
const providerServiceUrl = 'https://g-go-api2.augmedix.com/provider/v1';
const appointmentServiceUrl = 'https://g-go-api2.augmedix.com/appointment/v1';
const ehrServiceUrl = 'https://g-go-api2.augmedix.com/ehr/v1';
const macrosServiceUrl = 'https://g-go-api2.augmedix.com/macros/v1';
const transcriptServiceUrl = 'https://g-go-ml-api2.augmedix.com/transcript/v1';
const gwpServiceUrl = 'https://g-go-api2.augmedix.com/gwp/v1';
const signupServiceUrl = 'https://g-go-api2.augmedix.com/signup/v1';
const graphqlApiUrl = 'https://g-go-api2.augmedix.com/apollo-gateway/v1/graphql';
const nrtServerUrl = 'https://g-go-nrt.augmedix.com';
const userManagementServiceUrl = 'https://g-go-api2.augmedix.com/usermanagement/v1';
const ssoServiceUrl = 'https://g-go-api2.augmedix.com/saml/v1';
const textExpanderServiceUrl = 'https://g-go-api2.augmedix.com/textexpander/v1';

export const prodUrls = {
  authServiceUrl,
  providerServiceUrl,
  appointmentServiceUrl,
  ehrServiceUrl,
  transcriptServiceUrl,
  gwpServiceUrl,
  macrosServiceUrl,
  signupServiceUrl,
  graphqlApiUrl,
  nrtServerUrl,
  userManagementServiceUrl,
  ssoServiceUrl,
  textExpanderServiceUrl,
};
